export const imgFallback = site_code => {
  switch (site_code) {
    case "/zl":
      return "/static/icon/zl.jpg";
      break;
    case "/cs":
      return "/static/icon/cs.jpg";
      break;
    case "/csdmnvz":
      return "/static/icon/csdmnvz.jpg";
      break;
    default:
      return "";
      break;
  }
};
export const imgFallbackLittle = site_code => {
  switch (site_code) {
    case "/zl":
      return "/static/icon/zl1.png";
      break;
    case "/cs":
      return "/static/icon/cs1.png";
      break;
    case "/csdmnvz":
      return "/static/icon/csdmnvz1.png";
      break;
    default:
      return "";
      break;
  }
};



// WEBPACK FOOTER //
// ./src/utils/fallbackImg.js